import { render, staticRenderFns } from "./template-detail.vue?vue&type=template&id=7ab34595"
import script from "./template-detail.vue?vue&type=script&lang=js"
export * from "./template-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports